import { z } from "@reflag/shared/utils/zod";

export const Permissions = [
  "reflag-admin",
  "admin",
  "write",
  "write:entities",
  "write:flag:targeting:production",
  "write:flag:targeting:non-production",
  "write:segment",
  "create:flag",
  "write:flag",
  "delete:flag",
  "archive:flag",
  "read",
] as const;

export const PermissionSchema = z.enum(Permissions);
export type Permission = z.infer<typeof PermissionSchema>;

export const APIScopes = [
  "read",
  "create:flag",
  "write:flag:targeting",
  "write:entities",
] as const;

export const APIScopeSchema = z.enum(APIScopes);

export type APIScope = z.infer<typeof APIScopeSchema>;

export const MemberRoles = [
  "viewer",
  "contributor",
  "publisher",
  "admin",
] as const;

export const MemberRoleSchema = z.enum(MemberRoles);
export type MemberRole = z.infer<typeof MemberRoleSchema>;

const viewerPermissions = ["read"] as const;
const contributorPermissions = [
  ...viewerPermissions,
  "write",
  "create:flag",
  "write:flag",
  "write:flag:targeting:non-production",
] as const;

const publisherPermissions = [
  ...contributorPermissions,
  "write:flag:targeting:production",
  "archive:flag",
  "delete:flag",
  "write:segment",
] as const;

const adminPermissions = [
  ...publisherPermissions,
  "write:entities",
  "admin",
] as const;

export const MemberRolePermissions: Record<MemberRole, readonly Permission[]> =
  {
    viewer: viewerPermissions,
    contributor: contributorPermissions,
    publisher: publisherPermissions,
    admin: adminPermissions,
  };

export const APIScopePermissions: Record<APIScope, readonly Permission[]> = {
  read: ["read"],
  "create:flag": ["create:flag"],
  "write:flag:targeting": [
    "write:flag:targeting:non-production",
    "write:flag:targeting:production",
  ],
  "write:entities": ["write:entities"],
};
